import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService extends LocalStorageService {
  protected storage = sessionStorage;
}
